// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiReferral {
    static getAttributeTypeMap() {
        return MedicalBiReferral.attributeTypeMap;
    }
}
MedicalBiReferral.discriminator = undefined;
MedicalBiReferral.additionalProperties = false;
MedicalBiReferral.attributeTypeMap = [
    {
        "name": "effectiveDate",
        "baseName": "effectiveDate",
        "type": "Date"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "onFile",
        "baseName": "onFile",
        "type": "boolean"
    },
    {
        "name": "recertDate",
        "baseName": "recertDate",
        "type": "Date"
    },
    {
        "name": "required",
        "baseName": "required",
        "type": "boolean"
    },
    {
        "name": "requirements",
        "baseName": "requirements",
        "type": "string"
    },
    {
        "name": "visitsApproved",
        "baseName": "visitsApproved",
        "type": "string"
    },
    {
        "name": "visitsUsed",
        "baseName": "visitsUsed",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiReferral.js.map